// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export abstract class environment {
  public static production = false;
  public static apiUrl: string;
  public static rootUrl: string;
  public static systemId: string;
  public static apiCore: string;
  public static apiNotificationUrl: string;
  public static systemExternalCode: string;
  public static reportViewTimeout: number;
}